module.exports = __webpack_public_path__ + "img/tob-design-logo.58053b28.svg";